import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import api from "api";
import FormBuilderSummary from "components/formbuilder/FormBuilderSummary";
import { applyConditionalDisplay } from "components/formbuilder/utils/applyConditionalDisplay";
export default function RequestSummaryModal({ requestId, show, onClose }) {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);

  // Chargement du résumé
  useEffect(() => {
    api.get(`/formalities/request/${requestId}/summary`).then(res => {
      const rawSchema = res.data.template.format.schema;
      const rawData = res.data.frData;
      const effectiveSchema = applyConditionalDisplay(rawSchema, rawData);
      setSummary({
        data: { ...res.data.frData },
        schema: effectiveSchema
      });
    });
  }, [requestId]);
  return (
    <Modal show={show} onHide={onClose} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Synthèse de la demande</Modal.Title>
      </Modal.Header>

      <Modal.Body >
        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" />
            <div className="mt-3">Chargement de la synthèse…</div>
          </div>
        )}

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {!loading && summary && (
          <div style={{ maxHeight: '70vh', overflowY: "auto" }}>
            <FormBuilderSummary
              schema={summary.schema}
              data={summary.data}
              errors={summary.errors || {}}
              visibility={summary.visibility || {}}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
